import { ICourseRequirement, ICreateCourseRequirement, type CourseRequirementType } from '@/types/courses';

type SessionId = number;
export const getRequirementMapBySession = (
  requirements: (ICourseRequirement | ICreateCourseRequirement)[] | undefined
) => {
  return (
    requirements?.reduce<Record<SessionId, CourseRequirementType[]>>((acc, req) => {
      if (acc[req.session_id]) {
        acc[req.session_id].push(req.type);
      } else {
        acc[req.session_id] = [req.type];
      }
      return acc;
    }, {}) ?? {}
  );
};
